import { Input, InputProps } from '@chakra-ui/react';
import { UseFormReturn, FieldPath } from 'react-hook-form';

type MenuNameInputProps<TFieldValues> = InputProps & {
  name: FieldPath<TFieldValues>;
  register: UseFormReturn<TFieldValues>['register'];
};

export const MenuNameInput = <TFieldValues,>({
  name,
  register,
  ...inputProps
}: MenuNameInputProps<TFieldValues>) => (
  <Input
    type="text"
    {...register(name, {
      required: '必須項目です。',
      maxLength: {
        value: 255,
        message: 'メニュー名は255文字以内にする必要があります。',
      },
    })}
    {...inputProps}
  />
);
